export * from './card-generator.component';
